import type { StudyImageDto } from "@gazelab/shared";
import { api } from "../../services/api.js";
import { fmtDuration } from "../../lib/format.js";
import { Icon } from "../ui/Icon.js";

/** Miniaturas de todos los estímulos del estudio (imágenes y videos) para elegir cuál analizar. */
export function StimulusPicker({ studyId, stimuli, value, onChange }: { studyId: string; stimuli: StudyImageDto[]; value: string; onChange: (id: string) => void }) {
  const current = stimuli.find((s) => s.id === value) ?? null;
  return (
    <>
      <div className="grid grid-cols-3 gap-1.5" role="group" aria-label="Elegir imagen o video">
        {stimuli.map((s, idx) => {
          const isVideo = s.kind === "video";
          return (
            <button
              key={s.id}
              type="button"
              aria-pressed={s.id === value}
              title={`${idx + 1}. ${s.filenameOriginal}${s.isActive ? "" : " (inactivo)"}`}
              onClick={() => onChange(s.id)}
              className={`relative aspect-[4/3] overflow-hidden rounded-lg ring-2 transition ${isVideo ? "bg-slate-900" : "bg-slate-100"} ${s.id === value ? "ring-sky-600" : "ring-transparent hover:ring-slate-300"}`}
              data-testid="stimulus-thumb"
              data-kind={s.kind}
            >
              {(!isVideo || s.hasPoster) && (
                <img
                  src={isVideo ? api.adminPosterUrl(studyId, s.id) : api.adminImageUrl(studyId, s.id)}
                  alt=""
                  loading="lazy"
                  className={`h-full w-full object-cover ${s.isActive ? "" : "opacity-40"}`}
                />
              )}
              <span className="absolute left-1 top-1 inline-flex items-center gap-0.5 rounded bg-ink/75 px-1 font-util text-[0.65rem] text-white">
                {idx + 1}
                {isVideo && <Icon name="video" className="h-3 w-3" />}
              </span>
              {isVideo && <span className="absolute bottom-1 right-1 rounded bg-ink/75 px-1 font-util text-[0.6rem] text-white">{fmtDuration(s.durationMs)}</span>}
            </button>
          );
        })}
      </div>
      {current && (
        <p className="truncate text-xs text-slate-500" title={current.filenameOriginal}>
          {current.kind === "video" ? "Video" : "Imagen"} · {current.filenameOriginal} · {current.naturalWidth}×{current.naturalHeight}
        </p>
      )}
    </>
  );
}
